(function () {
  'use strict';

  angular.module('ringbaPortal')
    .controller('TargetGroupsController', TargetGroupsController);

  function TargetGroupsController(
    _,
    $filter,
    $log,
    $scope,
    $state,
    $stateParams,
    $interval,
    $timeout,
    $translate,
    $uibModal,
    accountsService,
    targetGroupService,
    bsLoadingOverlayService,
    isMobileDevice,
    userSettingsService,
    columnsFetchService,
    statsService,
    csvExportService,
    toaster,
    utils
  ) {

    const vm = this;
    let timer;

    vm.currentAccountId = accountsService.currentAccountId;
    vm.columnSettings = targetGroupService.columnSettings;
    vm.userSettings = {};
    vm.loading = true;
    vm.targetGroups = [];
    vm.tableSearch = '';

    vm.$onInit = onInit;
    vm.exportToCSV = exportToCSV;
    vm.viewGroup = viewGroup;
    vm.dropSuccess = dropSuccess;
    vm.toggleEnabled = toggleEnabled;
    vm.toggleTargetDisabled = toggleTargetDisabled;
    vm.getTargetNamesSplitByComma = getTargetNamesSplitByComma;
    vm.activateTargetGroupActions = activateTargetGroupActions;
    vm.confirmResetCapCounters = confirmResetCapCounters;
    vm.resetCapCounters = resetCapCounters;
    vm.cancelModal = cancelModal;
    vm.confirmDeleteModal = confirmDeleteModal;
    vm.confirmDelete = confirmDelete;
    vm.setForceUnlink = setForceUnlink;

    vm.showForm = showForm;
    vm.hideForm = hideForm;
    vm.onSave = onSave;

    function onInit() {
      vm.isAdmin = accountsService.isAdmin();
      vm.isMobileView = isMobileDevice;
      vm.createAccess = accountsService.hasAccess('TargetGroup', 'CREATE');

      vm.activeTargetGroup = null;
      vm.showSpecificRecordDetails = $stateParams.targetGroupId;
      _setViewDetails(vm.showSpecificRecordDetails);

      userSettingsService.getUserSettings()
        .then(function (userSettings) {
          vm.userSettings = userSettings;
          vm.columns = columnsFetchService.getColumnList(userSettings, targetGroupService.defaultColumns, 'targetGroups');
          return _loadData();
        })
        .catch(_errorHandler);

      timer = $interval(function () {
        targetGroupService.getTargetGroups(vm.currentAccountId, true, {
          targetGroups: vm.targetGroups
        }, true).catch(_errorHandler);
      }, 15000);
    }

    function toggleEnabled(targetGroup) {
      if (!vm.formActive) {
        const targetGroupCopy = _.cloneDeep(targetGroup);
        targetGroupCopy.enabled = !targetGroupCopy.enabled;
        return targetGroupService.updateTargetGroupProperty(vm.currentAccountId, targetGroup.id, { enabled: targetGroupCopy.enabled })
          .then(function (updated) {
            targetGroup.enabled = updated.data.targetGroup.enabled;
            _updateTargetStatsAfterEnableDisable(targetGroup, updated.data.stats);
          })
          .catch(function (error) {
            _errorHandler(error);
            $log.getInstance('TargetsController').info('Error', error);
          });
      }
    }

    function toggleTargetDisabled(targetGroup) {
      if (!vm.formActive) {
        const targetGroupCopy = _.cloneDeep(targetGroup);
        targetGroupCopy.disableTargets = !targetGroupCopy.disableTargets;
        targetGroupCopy.enabled = !targetGroupCopy.disableTargets;
        return targetGroupService.updateTargetGroupProperty(vm.currentAccountId, targetGroup.id, {
          disableTargets: targetGroupCopy.disableTargets,
          enabled: targetGroupCopy.enabled
        })
          .then(function (updated) {
            targetGroup.disableTargets = updated.data.targetGroup.disableTargets;
            targetGroup.enabled = updated.data.targetGroup.enabled;
            _updateTargetStatsAfterEnableDisable(targetGroup, updated.data.stats);
          })
          .catch(function (error) {
            _errorHandler(error);
            $log.getInstance('TargetsController').info('Error', error);
          });
      }
    }

    function getTargetNamesSplitByComma(targetGroup) {
      if (targetGroup && targetGroup.targets) {
        return _.join(_.map(targetGroup.targets, 'name'), ', ');
      }
      return '';
    }

    function exportToCSV() {
      const exportHeaders = Object.entries(vm.columnSettings)
        .filter(function (entry) {
          return !entry[1].hide;
        })
        .map(function (entry) {
          const key = entry[0];
          const col = entry[1];
          return {
            label: $filter('translate')(col.displayName),
            // numTargets is keyed by column identity, not by stSort text,
            // because stSort ('targets.length || 0') is an Angular sort
            // expression, not a lodash path.
            value: key === 'numTargets'
              ? function (targetGroup) {
                return targetGroup.targets ? targetGroup.targets.length : 0;
              }
              : col.stSort
          };
        });
      // Scope the export to the active search box. displayGroups can't be used
      // here because it's paginated (20/page); instead re-run smart-table's own
      // global filter over the full set, then deep-copy so the shared
      // CsvExportService can't stamp fields onto the live table array.
      const rowsToExport = $filter('filter')(vm.targetGroups, vm.tableSearch);
      const filename = 'target-groups-' + new Date().toISOString().split('T')[0];
      csvExportService.exportCSVFile(exportHeaders, _.cloneDeep(rowsToExport), filename);
    }

    function dropSuccess(e, item, collection) {
      // collection contains the current ordering of columns
      // after the drag and drop. We need to save the
      // collection in user settings under targetGroups key
      return userSettingsService.getUserSettings()
        .then(function (userSettings) {
          vm.userSettings = userSettings;
          if (!vm.userSettings.targetGroups) {
            vm.userSettings.targetGroups = {};
          }
          vm.userSettings.targetGroups.columns = collection;
          return userSettingsService.saveUserSettings(vm.userSettings);
        });
    }


    function viewGroup(targetGroupId) {
      $state.go('dashboard.targetgroup.edit', {
        targetGroupId: targetGroupId
      });
    }

    function activateTargetGroupActions(targetGroupId) {
      vm.activeActionTargetGroupId = vm.activeActionTargetGroupId == targetGroupId ? false : targetGroupId;
    }

    function confirmResetCapCounters(targetGroup) {
      if (!vm.formActive) {
        vm.targetGroupForReset = targetGroup;
        vm.modalBodyText = $filter('translate')('RESET_COUNTERS_MODAL_BODY_WITH_NAME', { targetGroupName: vm.targetGroupForReset.name, target: 'Target Group' });
        vm.modal = $uibModal.open({
          templateUrl: '/scripts/shared/components/select-target/reset-target-group-counters.modal.html',
          scope: $scope,
          controllerAs: 'vm'
        });
      }
    }

    function resetCapCounters() {
      return targetGroupService.resetCallCounters(accountsService.currentAccountId, vm.targetGroupForReset.id)
        .then(function () {
          toaster.pop('success', $filter('translate')('RESET_COUNTERS_SUCCESS'));
          vm.cancelModal();
          vm.targetGroupForReset = null;
        })
        .catch(utils.errorHandler);
    }

    function cancelModal() {
      if (vm.modal) {
        vm.modal.close();
        vm.targetGroupForReset = null;
        vm.modalBodyText = null;
        vm.modal = null;
        vm.targetGroupForDelete = null;
      }
    }

    function setForceUnlink(value) {
      vm.forceUnlink = value;
    }

    function confirmDeleteModal(targetGroup) {
      if (!vm.formActive) {
        vm.targetGroupReferences = null;
        vm.targetGroupForDelete = targetGroup;
        _getTargetGroupReferences(targetGroup.id);
        vm.modal = $uibModal.open({
          templateUrl: '/scripts/components/targetgroups/delete-target-group.modal.html',
          scope: $scope,
          controllerAs: 'vm'
        });
      }
    }

    function confirmDelete() {
      return targetGroupService.deleteTargetGroup(accountsService.currentAccountId, vm.targetGroupForDelete.id, true).then(
        function () {
          toaster.pop('success', $translate.instant('DELETE_TARGET_GROUP_SUCCESSFUL_MESSAGE'));
          _.remove(vm.targetGroups, function (targetGroup) {
            return targetGroup.id === vm.targetGroupForDelete.id;
          });
          cancelModal();
        }).catch(_errorHandler);
    }

    function hideForm(targetGrp) {
      if (targetGrp) {
        targetGrp.showEditForm = false;
      } else {
        vm.showAddNewForm = false;
      }
      vm.formActive = false;
      vm.activeTargetGroup = null;

      if (vm.showSpecificRecordDetails || vm.targetIdToClone) {
        $state.go('dashboard.targetgroups');
      }
    }

    function showForm(targetGrp, $event) {
      if ($event) {
        $event.preventDefault();
      }
      if (!vm.showSpecificRecordDetails) {
        if (vm.activeTargetGroup) hideForm(vm.activeTargetGroup);
        vm.activeTargetGroup = targetGrp;
      }
      if (targetGrp) {
        vm.showAddNewForm = false;
        targetGrp.showEditForm = true;
      } else {
        vm.showAddNewForm = true;
      }
      vm.activeActionTargetGroupId = false;
      vm.formActive = true;
    }

    function onSave(group) {
      _loadData();

      // Don't hide form when specific record details are only being shown
      if (!vm.showSpecificRecordDetails) {
        hideForm(group);
      }
    }

    function _setViewDetails(showSpecificRecordDetails) {
      let loadingTranslation = 'TARGET_GROUPS_HEADER_LOADING';
      if (showSpecificRecordDetails) {
        loadingTranslation = 'TARGET_GROUP_HEADER_LOADING';
      } else {
        $translate('TARGET_GROUPS_HEADER').then(function (translation) {
          vm.widgetTitle = translation;
        });
      }

      $translate(loadingTranslation).then(function (translation) {
        vm.loadingText = translation;
      });
    }

    function _getTargetGroupReferences(targetGroupId) {
      vm.checkReferencesText = 'DELETE_TARGET_GROUP_MODAL_CHECK_ASSOCIATION_TEXT';
      bsLoadingOverlayService.start();
      vm.hasReferences = false;
      targetGroupService.getTargetGroupReferences(accountsService.currentAccountId, targetGroupId).then(function (response) {
        // We're using timeout here to show the user the checking targetGroup references text
        $timeout(function () {
          bsLoadingOverlayService.stop();
          vm.targetGroupReferences = response.data;
          vm.hasReferences = vm.targetGroupReferences.hasReferences && ((vm.targetGroupReferences.campaigns && vm.targetGroupReferences.campaigns.length) || (vm.targetGroupReferences.callplans && vm.targetGroupReferences.callplans.length));
        }, 800);
      }).catch(function () {
        vm.checkReferencesText = 'DELETE_TARGET_GROUP_MODAL_CHECK_ASSOCIATION_ERROR_TEXT';
        bsLoadingOverlayService.stop();
      });
    }

    function _updateTargetStatsAfterEnableDisable(target, updatedTargetStatsResponse) {
      const status = {
        isAcceptingCalls: target.enabled,
        blockReason: target.enabled ? '' : 'Disabled'
      };
      const usageStats = updatedTargetStatsResponse[utils.capFirstLetter(target.id)];
      statsService.normalizeStat(target, { status: status, usageStats: usageStats },  targetGroupService.blockReasonTranslation);
    }

    function _loadData() {
      if (vm.showSpecificRecordDetails) {
        return _loadTargetGroup($stateParams.targetGroupId);
      } else {
        return _loadTargetGroups();
      }
    }

    function _loadTargetGroups() {
      return targetGroupService.getTargetGroups(vm.currentAccountId, true, false, true)
        .then(function (response) {
          vm.targetGroups = response.data.targetGroups;
          bsLoadingOverlayService.stop();
          if (vm.targetGroups.length === 0) {
            vm.targetGroupsResults = false;
          }
          vm.loading = false;
        })
        .catch(_errorHandler);
    }

    function _loadTargetGroup(targetGroupId) {
      targetGroupService.getTargetGroup(accountsService.currentAccountId, targetGroupId)
        .then(function (targetGroup) {
          vm.targetGroups = [targetGroup];
          vm.widgetTitle = 'Target Group: ' + targetGroup.name;
          showForm(vm.targetGroups[0]);
          vm.loading = false;
        }).catch(utils.errorHandler);
    }

    function _errorHandler(error) {
      utils.errorHandler(error);
      bsLoadingOverlayService.stop();
    }

    // When the DOM element is removed from the page,
    // AngularJS will trigger the $destroy event on
    // the scope. This gives us a chance to cancel any
    // pending timer that we may have.
    $scope.$on(
      '$destroy',
      function () {
        $interval.cancel(timer);
      }
    );

    // Watch the items displayed in the table, if there is an active item when it changes, hide the edit form and clear active item
    $scope.$watch('vm.displayGroups', function() {
      if (vm.activeTargetGroup) hideForm(vm.activeTargetGroup);
      vm.showAddNewForm = false;
      vm.formActive = false;
    });
  }
})();
